module.exports = __webpack_public_path__ + "img/HelpInvoice.6b93dc7a.svg";